export default "__VITE_ASSET__CQNHixVO__"